import { Tab } from "@headlessui/react";
import clsx from "clsx";
import { useProduct } from "../../hooks/useProduct";
import useProductReviews from "../../hooks/useProductReviews";
import useReviewLength from "../../hooks/useReviewLength";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { addToCart, removeFromCart } from "../../features/cart/cart-slice";
import { Helmet } from "react-helmet-async";
import _ from "lodash";
import numeral from "numeral";
import { Fragment } from "react";
import { StarIcon } from "@heroicons/react/24/outline";
import {UserIcon} from "@heroicons/react/24/outline";

const Product: React.FunctionComponent = () => {
  const { id } = useParams();
  const { cartItems } = useAppSelector((state) => state.cart);
  const dispatch = useAppDispatch();
  const { shop } = useAppSelector((state) => state?.shop);

  
  
  const { product } = useProduct({
    filter: {
      id: {
        eq: id,
      },
      shop: {
        shop_id: {
          eq: shop?.id,
        },
      },
    },
  });
  const productid=product?.id;
  console.log(productid)
  const {reviews}=useProductReviews({
    
      filter: {
      id:{
        eq:productid
      },
        product_id: {
          eq:productid
        }
      },
      // pagination: {
      //   limit: 0,
      //   offset: 0
      // }
    
  
  });
  const {reviewlength}=useReviewLength({
    filter:{
      product_id:{
        eq:productid
      }
    }
  });
  

  const alreadyAdded = !_.isEmpty(
    _.find(cartItems, (el) => el.id === product?.id)
  );

  
  function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(' ')
  }


  return (
    <div className="bg-white">
      
      <Helmet>
      {/* <title> {product?.title}</title> */}
      <link rel="icon" type="image/png" href={product?.avatar}/>
      <meta property='og:title' content={product?.title}/>
        <meta property='og:description' content={shop?.name +"'s shop  - "+ product?.title }/>
        <meta property="og:image" itemProp="image"  content={product?.avatar}/>
        <meta property="og:type" content="website"/>
        <meta property="og:image:type" content="image/png"/>
        <meta property="og:image:width" content="300"/>
        <meta property="og:image:height" content="300"/>  
      </Helmet>
      <div className="mx-auto max-w-2xl py-16 px-4 sm:py-24 sm:px-6 lg:max-w-7xl lg:px-8">
        <div className="lg:grid lg:grid-cols-2 lg:items-start lg:gap-x-8">
          {/* Image gallery */}
          <Tab.Group as="div" className="flex flex-col-reverse">
            <div className="mx-auto mt-6  w-full max-w-2xl sm:block lg:max-w-none">
              <Tab.List className="grid grid-cols-4 gap-6">
                {product?.media?.map((image: any) => (
                  <Tab
                    key={image?.id}
                    className="relative flex lg:h-24 h-16 cursor-pointer items-center justify-center rounded-md bg-white text-sm font-medium uppercase text-gray-900 hover:bg-gray-50 focus:outline-none  focus:ring-opacity-50 focus:ring-offset-4"
                  >
                    {({ selected }) => (
                      <>
                        <span className="absolute inset-0 overflow-hidden rounded-md">
                          <img
                            src={image?.avatar ?? ""}
                            alt=""
                            className="h-full w-full object-cover object-center"
                          />
                        </span>
                        <span
                          className={clsx(
                            selected ? "ring-2 ring-pink-500" : "ring-transparent",
                            "pointer-events-none absolute inset-0 rounded-md  ring-offset-2"
                          )}
                          aria-hidden="true"
                        />
                      </>
                    )}
                  </Tab>
                ))}
              </Tab.List>
            </div>

            <Tab.Panels className="aspect-w-1 aspect-h-1 w-full">
              {product?.media?.map((image: any) => (
                <Tab.Panel key={image?.id}>
                  <img
                    src={image?.avatar ?? ""}
                    alt={product?.title}
                    className="h-full w-full object-cover object-center sm:rounded-lg"
                  />
                </Tab.Panel>
              ))}
            </Tab.Panels>
          </Tab.Group>

          {/* Product info */}
          <div className="mt-10 px-4 sm:mt-16 sm:px-0 lg:mt-0">
            <h1 className="text-xl lg:text-3xl font-medium tracking-tight text-gray-900">
              {product?.title}
            </h1>

            <div className="mt-3">
              <h2 className="sr-only">Product information</h2>
              <p className="text-3xl tracking-tight text-gray-900">
                <>
                  {product?.currency}{" "}
                  {numeral(
                    _.sum([product?.price ?? 0, product?.profit_added ?? 0])
                  ).format("#,#")}
                </>
              </p>
            </div>

           

            <form className="mt-6">
              <div className="sm:flex-col1 mt-10 flex">
                <button
                  type="button"
                  onClick={() =>
                    alreadyAdded
                      ? dispatch(removeFromCart(product))
                      : dispatch(addToCart(product))
                  }
                  className={clsx(
                    "flex max-w-xs flex-1 items-center justify-center rounded-full border border-transparent  py-3 px-8 text-base font-medium text-white  focus:outline-none focus:ring-2  focus:ring-offset-2 focus:ring-offset-gray-50 sm:w-full",
                    {
                      "bg-pink-500 hover:bg-black focus:ring-pink-500":
                        !alreadyAdded,
                      "bg-red-600 hover:bg-red-700 focus:ring-red-500 ":
                        alreadyAdded,
                    }
                  )}
                >
                  {!alreadyAdded ? "Add to Cart" : "Remove from cart"}
                </button>
              </div>
            </form>
            <div className="mt-6">
              <h3 className="sr-only">Description</h3>

              <div
                className="space-y-6 text-base text-gray-700"
                dangerouslySetInnerHTML={{ __html: product?.description ?? "" }}
              />
            </div>

            <section aria-labelledby="details-heading" className="mt-12">
              <h2 id="details-heading" className="sr-only">
                Additional details
              </h2>
            </section>
          <section>
              
             

             
            <div className="mx-auto mt-16 w-full max-w-2xl lg:col-span-4 lg:mt-0 lg:max-w-none">
            <Tab.Group as="div">
              <div className="border-b border-gray-200">
                <Tab.List className="-mb-px flex space-x-8">
                  <Tab
                    className={({ selected }) =>
                      classNames(
                        selected
                          ? 'border-orange-500 text-orange-500'
                          : 'border-transparent text-gray-700 hover:border-gray-300 hover:text-gray-800',
                        'whitespace-nowrap border-b-2 py-6 text-sm font-medium'
                      )
                    }
                  >
                    Customer Reviews <span className="text-lg">({reviewlength!})</span>
                  </Tab>
                  
                </Tab.List>
              </div>
              <Tab.Panels as={Fragment}>
                <Tab.Panel className="-mb-10">
                  <h3 className="sr-only">Customer Reviews </h3>
                  

                  {reviews.map((review) => (
                    <div key={review?.id!} className="flex space-x-4 text-sm text-gray-500">
                      <div className="flex-none py-4">
                        <UserIcon  className="h-8 w-8 pt-2 mt-6 rounded-full bg-gray-100" />
                      </div>
                      <div className={classNames(reviews.length === 0 ? '' : 'border-t border-gray-200', 'py-6')}>
                        <h3 className="font-medium text-gray-900">User</h3>
                        
                        <div className="mt-2 flex items-center">
                          {[0, 1, 2, 3, 4].map((rating) => (
                            <StarIcon
                              key={rating}
                              className={classNames(
                                review?.rating! > rating ? 'text-yellow-500' : 'text-gray-300',
                                'h-5 w-5 flex-shrink-0'
                              )}
                              aria-hidden="true"
                            />
                          ))}
                        </div>
                        <p className="sr-only">{review?.rating} out of 5 stars</p>

                        <div
                          className="prose prose-sm mt-2 max-w-none text-gray-500"
                          dangerouslySetInnerHTML={{ __html: review?.comment || "No comment" }}
                        />
                      </div>
                    </div>
                  ))}
                </Tab.Panel>

               

                
              </Tab.Panels>
            </Tab.Group>
          </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Product;
